export const SUPABASE_URL = 'https://ypdpopphenmbtivdtlip.supabase.co'
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlwZHBvcHBoZW5tYnRpdmR0bGlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAwOTg1NzAsImV4cCI6MjA4NTY3NDU3MH0.mZCaMiqmZSBDCNXTNQCkfl0-uHv3ozHRvVmhEvi3WeQ'

export const GOLD_API_URL = 'https://api.gold-api.com/price/XAU'
export const FORMSPREE_ENDPOINT =
  import.meta.env.VITE_FORMSPREE_ENDPOINT ?? 'https://formspree.io/f/mjgondvv'
